import { render, staticRenderFns } from "./ReportTabLineage.vue?vue&type=template&id=8945dc14&scoped=true&lang=pug"
import script from "./ReportTabLineage.vue?vue&type=script&lang=js"
export * from "./ReportTabLineage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8945dc14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8945dc14')) {
      api.createRecord('8945dc14', component.options)
    } else {
      api.reload('8945dc14', component.options)
    }
    module.hot.accept("./ReportTabLineage.vue?vue&type=template&id=8945dc14&scoped=true&lang=pug", function () {
      api.rerender('8945dc14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/datastudio/components/ReportTabLineage.vue"
export default component.exports